import React from "react";

import NumericStepper from "../numericStepper";
import provisionalModuleDataBasedOnLanguage from "../../modules/lodging/supplierPage/provisionalModuleDataBasedOnLanguage";


const GuestSelector = ({
  accentColor,
  language = "no-NO",
  guests = [],
  setGuests = () => null,
  types,
  destinationColors = false,
  ageInterval,
  maxGuests
}) => {
  const updateGuests = (prevQuantity, quantity, type, ageRequired, minAge) => {
    const _guests = [...guests];

    if (prevQuantity > quantity) {
      const lastIndex = _guests.findLastIndex((_guest) => _guest.type === type);
      _guests.splice(lastIndex, 1);
    }

    if (prevQuantity < quantity) {
      _guests.push({ type, age: ageRequired && minAge ? minAge : 0 });
    }

    setGuests(_guests);
  };

  const updateAge = (age, index) => {
    const _guests = [...guests];

    _guests[index].age = age;

    setGuests(_guests);
  };

  const moduleData = provisionalModuleDataBasedOnLanguage(language)
  const defaultTypes = [
    {
      type: "adult",
      label: moduleData.adultsLabel,
      minRange: 1,
      maxRange: 15,
      minAge: 13,
      maxAge: false
    },
    {
      type: "child",
      label: moduleData.childrenLabel,
      minRange: 0,
      maxRange: 10,
      minAge: 0,
      maxAge: 12,
      ageRequired: true,
      ageRequiredLabel: moduleData.ageRequiredLabel,
      ageRequiredCaption: moduleData.ageRequiredCaption,
      ageLabel: moduleData.ageLabel,
    },
  ];

  function getAgeRequirement(minAge = "", maxAge = "", ageLabel = moduleData.ageLabel){
    if((minAge || minAge === 0) && maxAge) return `(${minAge} - ${maxAge} ${ageLabel})`
    if(!maxAge) return `(${minAge}+)`
    return ''
  }

  const provisionalTypes = types ? types : defaultTypes;

  const getMaxAmount = (maxAmount, maxGuests, ageCategoryType) => {
    const currentTotalGuests = guests.length;
    const remainingSpots = maxGuests - currentTotalGuests;
  
    // Calculate the number of guests already in this age category
    const currentCategoryGuests = guests.filter(guest => guest.type === ageCategoryType).length;
  
    // Return the minimum of the remaining spots + current category guests or the maxAmount
    return Math.min(maxAmount, remainingSpots + currentCategoryGuests);
  };

  return (
    <div className="grid gap-4 font-[600] text-[0.9375rem] leading-[1.175rem]">
      {provisionalTypes.map((_type, _idx) => {
        const {
          type,
          label,
          minRange,
          maxRange,
          minAge,
          maxAge,
          ageRequired,
          ageRequiredLabel,
          ageRequiredCaption,
          ageLabel,
        } = _type;
        const quantity = guests.filter((_guest) => _guest.type === type).length;
        const ageRequirementLabel = getAgeRequirement(minAge, maxAge);
        return (
          <React.Fragment key={`${type}_${label}_${_idx}`}>
            <div
              className="flex flex-row justify-between items-center gap-2"
              key={`${type}_${label}`}
            >
              <div className="flex gap-2">
                <span className={`${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : "text-[#242426]"}`}>{label}</span>
                <span className={`${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : "text-gray-500"}`}>{ageRequirementLabel}</span>
              </div>

              <NumericStepper
                onChange={(currentQuantity) =>
                  updateGuests(
                    quantity,
                    currentQuantity,
                    type,
                    ageRequired,
                    minAge
                  )
                }
                quantity={quantity}
                min={minRange}
                max={getMaxAmount(maxRange, maxGuests, type) }
                layout="rounded"
                accentColor={accentColor}
                destinationColors={destinationColors}
              />
            </div>
            {ageRequired && quantity > 0 ? (
              <div className="grid gap-2">
                <p className={`${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : "text-[#242426]"}`}>
                  {ageRequiredLabel}{" "}
                  <span className={`${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : "text-[#75757D]"} leading-[1.01875rem] text-[0.8125rem]`}>
                    {ageRequiredCaption}
                  </span>
                </p>
                {guests.map((_guest, idx) => {
                  if (_guest.type !== type) return null;
                  return (
                    <div
                      className={`flex flex-row justify-between gap-2 items-center border-2 ${destinationColors ? "border-[color:var(--highlightedSecondaryColor)] text-[color:var(--highlightedSecondaryColor)]" :  "border-[#EAEAF2]"} p-4 rounded-lg`}
                      key={`${type}_${label}_${_idx}_${idx}`}
                    >
                      <span className="">
                        {_guest.age} {ageLabel}
                      </span>
                      <NumericStepper
                        onChange={(q) => updateAge(q, idx)}
                        quantity={parseInt(_guest.age)}
                        min={minAge}
                        max={maxAge}
                        layout="rounded"
                        destinationColors={destinationColors}
                      />
                    </div>
                  );
                })}
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default GuestSelector;
